import Exposure from './events/exposure';
import Click from './events/click';
import PageLeave, { type CustomData } from './events/pageLeave';
import { type App, type Directive } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

// 埋点实例模块级单例：ccwork-jsbridge 的 setUser 可重入，
// native 多次回调会重复执行建应用逻辑，若无此保护会出现
// 两条上报链并发、缓存互相覆盖、曝光重复上报
let instances: { exp: Exposure; cli: Click } | null = null;

/**
 * 注册埋点指令
 * ⚠️ 必须在 setupStore(app) 之后调用：
 * 曝光实例化时会读取上次未上报的缓存并使用 Pinia store，
 * 若在模块求值期实例化（Pinia 尚未激活），存在缓存时会导致启动崩溃
 */
export function setupEventTrack(app: App) {
  // 实例化（幂等，仅首次真正创建）
  if (!instances) {
    instances = { exp: new Exposure(), cli: new Click() };
  }
  const { exp, cli } = instances;
  const trackDirective: Directive = {
    mounted(el, binding) {
      const { arg } = binding;
      arg?.split('|').forEach((item: string) => {
        // 点击
        if (item === 'click') {
          cli.add({ el });
        } else if (item === 'exposure') {
          exp.add({ el });
        }
      });
    },
  };
  app.directive('track', trackDirective);
}

/**
 * 页面停留时长统计插件
 *
 * 监听了 pageshow, pagehide, beforeunload, unload 事件
 * 在页面离开时，会将当前页面的离开时间记录
 * @returns
 * pageLeaveStart: (data?: CustomData) => void - 开始记录离开时间
 * pageLeaveEnd: () => void - 结束记录离开时间
 */
export function usePageLeave(data?: CustomData) {
  const pageLeave = new PageLeave();
  if (data) {
    pageLeave.start(data);
  }
  const events = ['pageshow', 'pagehide', 'beforeunload', 'unload'];
  const eventFuncs = events.map((item) => {
    if (item === 'pageshow') {
      return () => {
        console.log('event name is ' + item);

        pageLeave.reset();
        pageLeave.start();
      };
    } else {
      return () => {
        console.log('event name is ' + item);

        pageLeave.end();
        pageLeave.reset();
      };
    }
  });

  // 监听页面离开
  events.forEach((event, index) => {
    if (`on${event}` in window) {
      window.addEventListener(event, eventFuncs[index]);
    }
  });

  // 监听Vue页面离开
  onBeforeRouteLeave(() => {
    console.log('onBeforeUnmount');

    pageLeave.end();
    pageLeave.reset();
    events.forEach((event, index) => {
      if (`on${event}` in window) {
        window.removeEventListener(event, eventFuncs[index]);
      }
    });
  });

  return {
    pageLeaveStart: pageLeave.start.bind(pageLeave),
    pageLeaveEnd: pageLeave.end.bind(pageLeave),
  };
}
